import { useCallback, useEffect, useState } from "react";

import { Button, ErrorUI, SVGSprite } from "@/components/Atoms";
import ModalMotion from "@/components/Molecules/Modal";
import { AnimateDirection } from "@/components/Molecules/ModalMotion";

import WaitListModal from "../WaitListModal";

import { useAppDispatch, useAppSelector } from "@/hooks";

import * as actions from "@/redux/ShyftPassReducer";

const BookingAndCancelFlow: React.FC<any> = (props) => {
  const {
    encodedId,
    onboardId,
    centerId,
    slotBookedStatus,
    bookingId,
    hasAllSlotsBooked,
    centerTiming,
    allSlotsBookedMessage,
    isWaitListEnabled,
    isWaitListJoined,
  } = props;

  const dispatch = useAppDispatch();

  const { bookingSuccess, bookingError } = useAppSelector(
    (state) => state.shyftPass
  );

  const bookClass = useCallback(
    (data) => dispatch(actions.bookClass({ data })),
    [dispatch]
  );

  const cancelClass = useCallback(
    (data) => dispatch(actions.cancelClass(data)),
    [dispatch]
  );

  const resetBookingError = useCallback(
    () => dispatch(actions.resetBookingError()),
    [dispatch]
  );
  const resetBookingSuccess = useCallback(
    () => dispatch(actions.resetBookingSuccess()),
    [dispatch]
  );

  const [openSlotCancelModal, setOpenSlotCancelModal] = useState(false);
  const [openSlotBookModal, setOpenSlotBookModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openWaitListModal, setOpenWaitListModal] = useState(false);

  useEffect(() => {
    if (bookingError) {
      setOpenSlotBookModal(false);
      setOpenErrorModal(true);
    } else {
      setOpenErrorModal(false);
    }
  }, [bookingError]);

  useEffect(() => {
    if (bookingSuccess) {
      setOpenSlotBookModal(true);
    } else {
      setOpenSlotBookModal(false);
    }
  }, [bookingSuccess]);

  const arrowIcon = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-book-slot"
      height="24px"
      width="24px"
    />
  );

  const successIcon = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-success"
      height="24px"
      width="24px"
      fill="#fff"
    />
  );

  let button;
  if (slotBookedStatus) {
    button = (
      <>
        <Button variant={"primary1"} TextColor="#32D583">
          Slot booked
          {successIcon}
        </Button>
        <Button
          variant={"primary1"}
          onClick={() => {
            setOpenSlotCancelModal(true);
          }}
          className="booking-cancel-button"
        >
          Cancel booking
        </Button>
      </>
    );
  } else if (hasAllSlotsBooked) {
    if (isWaitListEnabled) {
      button = (
        <div className="wait-list-wrapper">
          <ErrorUI
            error={allSlotsBookedMessage || "All slots are booked!"}
            isNotAbsolute
            iconDimension="18px"
            fontSize="14px"
            lineHeight="24px"
          />
          {isWaitListJoined ? (
            <Button variant={"primary1"} TextColor="#32D583">
              Added to waitlist
              {successIcon}
            </Button>
          ) : (
            <Button
              variant={"primary1"}
              onClick={() => setOpenWaitListModal(props)}
            >
              Join the waitlist
              {arrowIcon}
            </Button>
          )}
        </div>
      );
    } else {
      button = (
        <Button variant={"primary1"} className="all-slots-booked" disabled>
          All slots are booked
        </Button>
      );
    }
  } else {
    button = (
      <Button
        variant={"primary1"}
        onClick={() => {
          bookClass({
            encoded_id: encodedId,
            onboard_id: onboardId,
            center: centerId,
            center_timing: centerTiming,
            is_active: true,
            is_deleted: false,
          });
        }}
      >
        Book your slot
        {arrowIcon}
      </Button>
    );
  }

  const slotCancelModal = (
    <ModalMotion
      overlayClosable={true}
      onClose={() => {
        setOpenSlotCancelModal(false);
      }}
      width="60%"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      // btnPos={btnPos}
      bodyPadding={"40px"}
    >
      {openSlotCancelModal && (
        <div className="slot-cancel-modal">
          <div className="modal-top-section">
            <p className="title">
              Are you sure you want to cancel this booking?
            </p>
            <p className="description">
              Slots are limited at some locations. You might not be able to book
              your slot again.
            </p>
          </div>
          <Button
            variant={"primary1"}
            onClick={() => {
              cancelClass({
                bookingId,
                data: {
                  encoded_id: encodedId,
                  onboard_id: onboardId,
                  center: centerId,
                  center_timing: centerTiming,
                  is_active: false,
                  is_deleted: true,
                },
              }).then(() => setOpenSlotCancelModal(false));
            }}
          >
            Yes, Cancel this booking
          </Button>
        </div>
      )}
    </ModalMotion>
  );

  const slotBookModal = (
    <ModalMotion
      overlayClosable={true}
      onClose={() => resetBookingSuccess()}
      width="60%"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose={false}
      iconTopPosition="20px"
      iconRightPosition="20px"
      // btnPos={btnPos}
      bodyPadding={"40px"}
    >
      {openSlotBookModal && (
        <div className="slot-book-modal">
          <SVGSprite
            className="icon"
            icon="icon-check-circle-1"
            height="86px"
            width="86px"
          />
          <p className="description">Your slot for this class is booked!</p>

          <Button variant={"primary1"} onClick={() => resetBookingSuccess()}>
            Done
          </Button>
        </div>
      )}
    </ModalMotion>
  );

  const errorModal = (
    <ModalMotion
      overlayClosable={true}
      onClose={() => {
        resetBookingError();
      }}
      width="60%"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose={false}
      iconTopPosition="20px"
      iconRightPosition="20px"
      // btnPos={btnPos}
      bodyPadding={"40px"}
    >
      {openErrorModal && (
        <div className="slot-book-modal">
          <SVGSprite
            className="icon"
            icon="icon-danger"
            height="86px"
            width="86px"
          />
          <p className="description">
            {bookingError?.message || "Someting went wrong"}
          </p>
          <Button
            variant={"primary1"}
            onClick={() => {
              resetBookingError();
            }}
          >
            Okay
          </Button>
        </div>
      )}
    </ModalMotion>
  );

  const waitListModal = (
    <WaitListModal
      openWaitListModal={openWaitListModal}
      setOpenWaitListModal={setOpenWaitListModal}
    />
  );

  return (
    <>
      <div className="slot-book-section">{button}</div>
      {openSlotCancelModal && slotCancelModal}
      {openSlotBookModal && slotBookModal}
      {openErrorModal && errorModal}
      {openWaitListModal && waitListModal}
    </>
  );
};

export default BookingAndCancelFlow;
